import Immutable from 'immutable';
import { SET_INSTITUTION_ENROLMENT } from './actions';

const initialState = Immutable.Map();

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function InstitutionEnrolments(state = initialState, action = {}) {
  switch (action.type) {
    case SET_INSTITUTION_ENROLMENT: {
      const { institutionEnrolment } = action;
      const newState = state;
      return newState.set(
        institutionEnrolment.path,
        Immutable.Map(institutionEnrolment)
      );
    }
    default: {
      return state;
    }
  }
}
